import { render } from "./ProfileUserView.vue?vue&type=template&id=4a4318c8&scoped=true"
import script from "./ProfileUserView.vue?vue&type=script&lang=js"
export * from "./ProfileUserView.vue?vue&type=script&lang=js"

import "./ProfileUserView.vue?vue&type=style&index=0&id=4a4318c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4318c8"]])

export default __exports__